/*
 * Class name merger.
 *
 * Wraps `clsx` for conditional joining and `tailwind-merge` for
 * de-duplicating conflicting Tailwind utilities (e.g. `p-2` overrides
 * `p-4` when both are supplied via different layers). The combination
 * is the de-facto standard for Tailwind component libraries.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
